import { API_BASE, messageFromErrorBody } from './authApi';
import { authHeaders } from './authStorage';

const jsonHeaders = () => ({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  ...authHeaders(),
});

export async function fetchSuperAdminMemberCompanies() {
  const res = await fetch(`${API_BASE}/api/superadmin/members/companies`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ([]));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل الشركات'));
  const list = Array.isArray(data) ? data : [];
  return list.map((c) => ({ id: c.id, name: c.name }));
}

export async function fetchSuperAdminMembers(params = {}) {
  const {
    page = 1,
    pageSize = 10,
    q = '',
    companyId = '',
    isActive = 'all',
    hasAccount = 'all',
    position = '',
    sortBy = 'name',
    sortDir = 'asc',
  } = params;

  const query = new URLSearchParams();
  query.set('page', String(page));
  query.set('pageSize', String(pageSize));
  query.set('sortBy', sortBy);
  query.set('sortDir', sortDir);
  if (q.trim()) query.set('q', q.trim());
  if (companyId) query.set('companyId', String(companyId));
  if (isActive === 'active') query.set('isActive', 'true');
  if (isActive === 'inactive') query.set('isActive', 'false');
  if (hasAccount === 'yes') query.set('hasAccount', 'true');
  if (hasAccount === 'no') query.set('hasAccount', 'false');
  if (position.trim()) query.set('position', position.trim());

  const res = await fetch(`${API_BASE}/api/superadmin/members?${query.toString()}`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل الأعضاء'));

  const list = Array.isArray(data.items) ? data.items : [];
  return {
    items: list.map((m) => ({
      id: m.id,
      companyId: m.companyId,
      companyName: m.companyName ?? '',
      name: m.name ?? '',
      position: m.position ?? '',
      phone: m.phone ?? '',
      email: m.email ?? '',
      userName: m.userName ?? '',
      hasAccount: !!m.hasAccount,
      isActive: !!m.isActive,
    })),
    page: Number(data.page) || 1,
    pageSize: Number(data.pageSize) || pageSize,
    total: Number(data.total) || 0,
    totalPages: Number(data.totalPages) || 0,
    positions: Array.isArray(data.positions) ? data.positions : [],
  };
}

export async function createSuperAdminMember(payload) {
  const res = await fetch(`${API_BASE}/api/superadmin/members`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر إضافة العضو'));
  return data;
}

export async function updateSuperAdminMember(id, payload) {
  const res = await fetch(`${API_BASE}/api/superadmin/members/${id}`, {
    method: 'PUT',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحديث العضو'));
  return data;
}

export async function deactivateSuperAdminMember(id) {
  const res = await fetch(`${API_BASE}/api/superadmin/members/${id}`, {
    method: 'DELETE',
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  if (res.status === 204) return;
  const data = await res.json().catch(() => ({}));
  throw new Error(messageFromErrorBody(data, 'تعذر تعطيل العضو'));
}
